import { render, staticRenderFns } from "./BranchAreaMailsModalComponent.vue?vue&type=template&id=bb791d8a&scoped=true"
import script from "./BranchAreaMailsModalComponent.vue?vue&type=script&lang=js"
export * from "./BranchAreaMailsModalComponent.vue?vue&type=script&lang=js"
import style0 from "./BranchAreaMailsModalComponent.vue?vue&type=style&index=0&id=bb791d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb791d8a",
  null
  
)

export default component.exports